import { Component, OnInit, numberAttribute, input } from '@angular/core';
import { NumberService } from '../../services/number/number.service';

/**
 * Image Placeholder Component
 *
 * Creates place holder for img tags with same height/width
 * as img before image load is complete.
 * Helps to keep div height while the image is loading.
 * Uses aspectRatio (width:height) to calculate height percantage
 *
 * @example
 * <td-wb-image-placeholder aspectRatio="16:9">
 *  <img src="someimage.jpg">
 * </td-wb-image-placeholder>
 *
 */
@Component({
  selector: 'td-wb-image-placeholder',
  templateUrl: './image-placeholder.component.html',
  styleUrls: ['./image-placeholder.component.scss']
})
export class ImagePlaceholderComponent implements OnInit {
  readonly aspectRatio = input<string>('1:1');

  heightPercentage: number = 100;

  ngOnInit(): void {
    const aspectRatio = this.aspectRatio();
    if (aspectRatio !== undefined) {
      const aspectRatioValues =  aspectRatio.split(':');
      if (aspectRatioValues.length === 2) {
        const width  = numberAttribute(aspectRatioValues[0], 1);
        const height = numberAttribute(aspectRatioValues[1], 1);
        if (width !== 0) {
          this.heightPercentage = (height / width) * 100;
          this.heightPercentage = NumberService.round(this.heightPercentage, 4);
        }
      }
    }
  }
}
